"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultParameters = {
  numOfSegments: 4,
  depth: 0,
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  centerX: 50,
  centerY: 50,
  rotate: 0,
  numOfGroups: 1,
  groups: [{
    type: "linear",
    incircle: false,
    round: 0.5,
    lengthBasedRound: false,
    adaptArms: false,
    distance: 1,
    smartRound: false,
    preserveRadians: false
  }]
};
exports.default = defaultParameters;